"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplyMessages = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("../../../../../../shared/core");
var copy_1 = require("../../../../copy");
var CommSmartMeterMessage = (0, react_1.forwardRef)(function (_a, ref) {
    var fuel = _a.fuel, rest = __rest(_a, ["fuel"]);
    var Callout = (0, core_1.useComponents)().Callout;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    return (react_1.default.createElement(Callout, __assign({ variant: "success", "data-testid": "smart-meter-comm-message" }, rest, { ref: ref }),
        react_1.default.createElement(Copy, { copyKey: "summaryCommMessage", values: { fuelType: fuel } })));
});
var NonCommSmartMeterMessage = (0, react_1.forwardRef)(function (_a, ref) {
    var fuel = _a.fuel, rest = __rest(_a, ["fuel"]);
    var Callout = (0, core_1.useComponents)().Callout;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    return (react_1.default.createElement(Callout, __assign({ variant: "warning", "data-testid": "smart-meter-non-comm-message" }, rest, { ref: ref }),
        react_1.default.createElement(Copy, { copyKey: "summaryNonCommMessage", values: { fuelType: fuel } })));
});
var MissingInfoMessage = (0, react_1.forwardRef)(function (props, ref) {
    var Callout = (0, core_1.useComponents)().Callout;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    return (react_1.default.createElement(Callout, __assign({ variant: "info", "data-testid": "missing-meter-info-message" }, props, { ref: ref }),
        react_1.default.createElement(Copy, { copyKey: "noMsn" })));
});
var SupplyMessages = function (_a) {
    var isSmart = _a.isSmart, isNonComms = _a.isNonComms, isOnboarding = _a.isOnboarding, missingSprn = _a.missingSprn, fuel = _a.fuel;
    var Stack = (0, core_1.useComponents)().Stack;
    var showSmartMeterMessage = isSmart && !isOnboarding;
    return showSmartMeterMessage || missingSprn ? (react_1.default.createElement(Stack, { spaceBetween: [2, 3] },
        showSmartMeterMessage ? (isNonComms ? (react_1.default.createElement(NonCommSmartMeterMessage, { fuel: fuel })) : (react_1.default.createElement(CommSmartMeterMessage, { fuel: fuel }))) : null,
        missingSprn ? react_1.default.createElement(MissingInfoMessage, null) : null)) : null;
};
exports.SupplyMessages = SupplyMessages;
